import {DeskAmenity} from '@lib/infrastructure';
import {constructFilter} from './constructFilter';
import {TFunction} from 'i18next';

export const SECTION_ID_DESK_AMENITY = 'SECTION_ID_DESK_AMENITY';

export const constructDeskAmenityFilter = <TEntity extends {deskAmenities: DeskAmenity[]}>(
  availableDeskAmenities: DeskAmenity[],
  getDeskAmenityIconName: (id: DeskAmenity) => string,
  t: TFunction,
) => {
  return constructFilter({
    sectionId: SECTION_ID_DESK_AMENITY,
    sectionTitle: t('deskAmenities:deskAmenity', {count: availableDeskAmenities.length}),
    type: 'and',
    data: availableDeskAmenities.map((id) => ({
      id,
      label: t(`deskAmenities:deskAmenity`, {context: id}),
      iconName: getDeskAmenityIconName(id),
    })),
    defaultFilterOptions: [],
    predicate: (filter, entity: TEntity) => entity.deskAmenities.includes(filter.id),
  });
};
